export default __webpack_public_path__ + "static/media/ic3.3c1fd22d.svg";